import React from 'react'
import { PRODUCT_TYPES } from '../../utils/constants'

function CategoryDropdown({ value, onChange, onBlur }) {
  const handleChange = (e) => {
    onChange(e.target.value)
    if (onBlur) onBlur()
  }

  return (
    <select
      value={value || ''}
      onChange={handleChange}
      className="category-select"
    >
      <option value="">— Select —</option>
      {PRODUCT_TYPES.map(type => (
        <option key={type} value={type}>{type}</option>
      ))}
    </select>
  )
}

export default CategoryDropdown
